module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABBElEQVR4Ac2PM2JFYRCFZw/hEtJFfZaQLrtIFdu2bauKbdu2dfmufYPm+TXB9xsz5wz8Cqo9FJGVDQ+qLDoQIHHi9TS7Uiy97OonywHC2TA7n8VvNzFTiWSrPzOTpDBvX0+mAcLZILtUiFd4vYfBeyS8BgKa4ys9b3y9mgZwm9VoqvtbMCAxgMTCWxhgBR7MeKx4OW45QHo/Jmv8kEhA4gDNdDZ0Boh3SyZuTS1x1Bt3vSCfDqjE7XcWWeZFUbEWsHF3W7E4O3t1JXx+OXt5ql+c7NlYtKrACPzwwVbKYM/o4fbq1VnBeF/t/MQd+m414It7DNH7E4HdIK8Ux9qqwS7wL9EAze2f8VGAnaIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CY.png
// module id = 1120
// module chunks = 0